//import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import { gridMargin } from './general';

export default class FMPSelect extends PureComponent {
	render() {
		const {
			label,
			value,
			path,
			onChange,
			readOnly,
			error,
			options,
			helpText,
			md,
			disabled,
			contained,
			multiple,
		} = this.props;

		const _onChange = (event) => {
			onChange(event.target.value, path);
		};

		//let value, onChange, error;
		const hasError = !!error;
		const content = (
			<Grid item xs={12} md={md} style={gridMargin}>
				<FormControl
					fullWidth={true}
					error={hasError}
					disabled={disabled}
					style={{ textAlign: 'left' }}
				>
					<InputLabel htmlFor={path}>{label}</InputLabel>
					<Select
						value={value}
						onChange={_onChange}
						input={<Input name={path} readOnly={readOnly} />}
						// input={<Input name={path} id={path} readOnly={readOnly} />}
						multiple={multiple}
					>
						{options.map((option) => {
							return (
								<MenuItem key={option.value} value={option.value}>
									{option.display}
								</MenuItem>
							);
						})}
					</Select>
					{hasError && <FormHelperText>{error}</FormHelperText>}
					{helpText && !hasError && <FormHelperText>{helpText}</FormHelperText>}
				</FormControl>
			</Grid>
		);

		if (contained) {
			return (
				<Grid spacing={2} container>
					{content}
				</Grid>
			);
		} else {
			return content;
		}
	}
}

FMPSelect.propTypes = {
	label: PropTypes.string.isRequired,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]).isRequired,
	path: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	error: PropTypes.string,

	options: PropTypes.array.isRequired,

	helpText: PropTypes.string,
	contained: PropTypes.bool,
	disabled: PropTypes.bool,
	md: PropTypes.number,
	multiple: PropTypes.bool,
	readOnly: PropTypes.bool,
};

FMPSelect.defaultProps = {
	contained: true,
	multiple: false,
	md: 12,
};
